import { TECHNOLOGY_SETUP_MAPPING } from '@/core/config/technologies'

const trimSlashes = (value: string): string => value.trim().replace(/^\/+|\/+$/g, '')

export const getConsumerFeedPrefix = (selectedTechnology: string): string => {
  const mapping = TECHNOLOGY_SETUP_MAPPING.find((entry) => entry.id === selectedTechnology)
  if (!mapping) {
    throw new Error(`No gateway feed endpoint configured for technology: ${selectedTechnology}`)
  }

  return `/${trimSlashes(mapping.path)}`
}
